import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@api";

function VerifyEmail() {
 const [searchParams] = useSearchParams();
 const navigate = useNavigate();
 const [status, setStatus] = useState("loading");

 useEffect(() => {
  const verify = async () => {
   const token = searchParams.get("token");

   if (!token) {
    setStatus("error");
    return;
   }

   try {
    await api.get(`/api/auth/verify-email?token=${token}`);
    setStatus("success");
   } catch (err) {
    setStatus("error");
   }
  };

  verify();
 }, [searchParams]);

 return (
  <div style={{
   minHeight: "100vh",
   display: "flex",
   justifyContent: "center",
   alignItems: "center",
   background: "#f5f7fa"
  }}>
   <div style={{
    background: "white",
    padding: "3rem",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    textAlign: "center",
    maxWidth: "420px",
    width: "100%"
   }}>

    {status === "loading" && (
     <>
      <h2 style={{ marginBottom: "1rem" }}>Verifying your email...</h2>
      <p style={{ color: "#666" }}>Please wait a moment.</p>
     </>
    )}

    {status === "success" && (
     <>
      <h2 style={{ marginBottom: "1rem", color: "#16a34a" }}>
       Email Verified 🎉
      </h2>
      <p style={{ marginBottom: "2rem", color: "#555" }}>
       Your account is now active.
      </p>
      <button
       onClick={() => navigate("/login")}
       style={{
        padding: "0.75rem 1.5rem",
        background: "#111",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer"
       }}
      >
       Go to Login
      </button>
     </>
    )}

    {status === "error" && (
     <>
      <h2 style={{ marginBottom: "1rem", color: "#dc2626" }}>
       Verification Failed
      </h2>
      <p style={{ marginBottom: "2rem", color: "#555" }}>
       This link may be invalid or expired.
      </p>
      <button
       onClick={() => navigate("/login")}
       style={{
        padding: "0.75rem 1.5rem",
        background: "#111",
        color: "white",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer"
       }}
      >
       Back to Login
      </button>
     </>
    )}

   </div>
  </div>
 );
}

export default VerifyEmail;